import { optionsMap } from 'pro-gallery-lib';
export var layoutOptions = [
    'LAYOUT',
    optionsMap.layoutParams.structure.galleryLayout,
    'IMAGE_DISPLAY',
    optionsMap.layoutParams.structure.scrollDirection,
    optionsMap.layoutParams.structure.layoutOrientation,
    optionsMap.layoutParams.crop.method,
    optionsMap.behaviourParams.item.content.loader,
    optionsMap.layoutParams.crop.ratios,
    'DESIGN_SETTINGS',
    optionsMap.layoutParams.structure.responsiveMode,
    optionsMap.layoutParams.targetItemSize.value,
    optionsMap.layoutParams.structure.itemSpacing,
    optionsMap.layoutParams.groups.density,
    optionsMap.layoutParams.structure.numberOfGridRows,
    optionsMap.layoutParams.structure.numberOfColumns,
    optionsMap.layoutParams.thumbnails.alignment,
    optionsMap.layoutParams.thumbnails.size,
    optionsMap.layoutParams.thumbnails.spacing,
    optionsMap.layoutParams.navigationArrows.enable,
    optionsMap.layoutParams.navigationArrows.size,
    optionsMap.layoutParams.navigationArrows.padding,
    optionsMap.layoutParams.navigationArrows.position,
    // optionsMap.layoutParams.navigationArrows.container.type,
    optionsMap.layoutParams.navigationArrows.verticalAlignment,
    optionsMap.behaviourParams.gallery.horizontal.slideTransition,
    optionsMap.behaviourParams.item.content.magnificationValue,
    'SLIDESHOW_SETTINGS',
    optionsMap.behaviourParams.gallery.horizontal.loop,
    optionsMap.behaviourParams.gallery.horizontal.autoSlide.behaviour,
    optionsMap.behaviourParams.gallery.horizontal.autoSlide.interval,
    optionsMap.behaviourParams.gallery.horizontal.autoSlide.speed,
    optionsMap.behaviourParams.gallery.horizontal.autoSlide.pauseOnHover,
    optionsMap.behaviourParams.gallery.horizontal.navigationDuration,
    'ADVANCED',
    optionsMap.behaviourParams.gallery.vertical.loadMore.enable,
    optionsMap.behaviourParams.gallery.vertical.loadMore.amount,
    optionsMap.behaviourParams.gallery.vertical.loadMore.text,
];
//# sourceMappingURL=layoutOptions.js.map